import { RouteRecordRaw, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const h5Routers: RouteRecordRaw[] = [
  {
    path: '/myCard',
    name: 'MyCard',
    component: () => import('@/pages/h5/MyCard/index.vue'),
    meta: {
      title: '我的卡片',
    },
  },
  {
    path: '/',
    redirect: '/home',
    name: 'EmptyIndex',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/h5/Index/Home/index.vue'),
    meta: {
      title: '首页',
      disabledNavBar: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/pages/404/index.vue'),
    meta: {
      title: '404',
    },
  },
  {
    path: '/serviceIm',
    name: 'serviceIm',
    component: () => import('@/pages/serviceTrrt/index.vue'),
    meta: {
      title: '客服',
    },
  },
  {
    path: '/jumpMpUrl',
    name: 'jumpMpUrl',
    component: () => import('@/pages/jumpMpUrl/index.vue'),
    meta: {
      title: '优客查查',
    },
  },
  {
    path: '/jumpToMini',
    name: 'JumpToMini',
    component: () => import('@/pages/jumpToMini.vue'),
    meta: { title: '打开小程序' },
  },
  {
    path: '/toMini',
    name: 'ToMini',
    component: () => import('@/pages/h5/Drainage/ToMini.vue'),
    meta: { title: '小程序' },
  },
  {
    path: '/linkInvalid',
    name: 'LinkInvalid',
    component: () => import('@/pages/h5/LinkInvalid.vue'),
    meta: { title: '链接失效' },
  },
  {
    path: '/linkfailure',
    name: 'Linkfailure',
    component: () => import('@/pages/h5/Linkfailure.vue'),
    meta: { title: '链接失效' },
  },
  {
    path: '/appGuide',
    name: 'AppGuide',
    component: () => import('@/pages/h5/inviting/appGuidePage.vue'),
    meta: { title: '下载应用' },
  },
  {
    path: '/appTransfer',
    name: 'AppTransfer',
    component: () => import('@/pages/transfer/AppTransfer.vue'),
    meta: { title: '', disabledNavBar: true },
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('@/pages/h5/Support.vue'),
    meta: { title: '技术支持' },
  },
  {
    path: '/cft/support',
    name: 'NewSupport',
    component: () => import('@/pages/h5/NewSupport.vue'),
    meta: { title: '技术支持' },
  },
  {
    path: '/handbook',
    name: 'Handbook',
    component: () => import('@/pages/h5/Index/Handbook/index.vue'),
    meta: { title: '赚钱宝典' },
  },
  {
    path: '/articleDetail',
    name: 'ArticleDetail',
    component: () => import('@/pages/h5/Index/ArticleDetail/index.vue'),
    meta: { title: '文章详情' },
  },
  {
    path: '/invitePerson',
    name: 'InvitePerson',
    component: () => import('@/pages/h5/Index/InvitePerson/index.vue'),
    meta: { title: '邀请下级' },
  },
  {
    path: '/pushReport',
    name: 'PushReport',
    component: () => import('@/pages/h5/Index/PushReport/index.vue'),
    meta: { title: '直推报告' },
  },
  {
    path: '/recommendation/:type?',
    name: 'Recommendation',
    component: () => import('@/pages/h5/Index/Recommendation/index.vue'),
    meta: { title: '报告推荐', disabledNavBar: true },
  },
  {
    path: '/property',
    name: 'Property',
    component: () => import('@/pages/h5/Property/index.vue'),
    meta: { title: '我的资产', disabledNavBar: true },
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('@/pages/h5/Login.vue'),
  //   meta: { title: '登录', disabledNavBar: true },
  // },
  {
    path: '/goPromote',
    name: 'GoPromote',
    component: () => import('@/pages/h5/GoPromote/index.vue'),
    meta: { title: '我要推广', disabledNavBar: true },
  },
  {
    path: '/otherGoPromote',
    name: 'OtherGoPromote',
    component: () => import('@/pages/h5/OtherGoPromote/index.vue'),
    meta: { title: '我要推广', disabledNavBar: true },
  },
  {
    path: '/vipCenter',
    name: 'VipCenter',
    component: () => import('@/pages/h5/VipCenter/index.vue'),
    meta: { title: '会员中心', disabledNavBar: true },
  },
  // 下载落地页
  {
    path: '/downloadOther',
    name: 'DownloadOther',
    component: () => import('@/pages/h5/Advertisement/DownloadOther/downloadLanding.vue'),
    meta: { title: '会员中心', disabledNavBar: true },
  },
];
